import { Subject } from 'rxjs';
import { Component, OnInit, Input, HostBinding, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MFormation } from '@argalis-apps/models';
import { FormationService } from '../../services/formation/formation.service';
import { CatalogConfigService } from '../../services/catalog-config/catalog-config.service';

import { throttleTime } from 'rxjs/operators';

@Component({
  selector: 'ags-fiche-formation-focus',
  templateUrl: './fiche-formation-focus.component.html',
  styleUrls: ['./fiche-formation-focus.component.scss']
})
export class FicheFormationFocusComponent implements OnInit, OnDestroy {
  @HostBinding('class') themeFlag: string;
  private _infoFormation: MFormation.IFormInfo = {} as MFormation.IFormInfo;
  private _initSubscrition = null;
  private getModalite = false;
  public id;
  public moda = '1';
  public keyupObservable = new Subject();

  public modalite;
  @Input('modalite')
  set _modalite(value) {
    this.modalite = value;
  }

  @Input()
  set infoFormation(value: MFormation.IFormInfo) {
    if (!value) {
      return;
    }
    this._infoFormation = value;
    if (this._infoFormation && !this.getModalite) {
      this.getModalite = true;
      this.getFormModaliteList(this._infoFormation.id, this._infoFormation.isParcours);
    }
    if (this._initSubscrition) {
      return;
    }
  }
  get infoFormation(): MFormation.IFormInfo {
    return this._infoFormation;
  }

  listModalite: MFormation.IModaliteInfo[] = [];
  selectedModa: number;
  postal: string;
  styleBGColor: any = {
    'background-color': 'rgb(255, 240, 197)',
    position: 'absolute',
    top: '0',
    left: '0',
    width: '100%',
    height: '100%',
    'z-index': '-1'
  };
  private finishedGetFormModaliteList = new Subject<any>();
  private queryObs;
  private fgfmObs;
  private defaultModa = [1, 2, 3];

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private formationService: FormationService,
    catalogConfigService: CatalogConfigService
  ) {
    this.themeFlag = `${this.themeFlag || ''} ${catalogConfigService.themingClassName}`;
  }

  ngOnInit() {
    this.queryObs = this.route.queryParams.subscribe(all => {
      const qParams = all;
      if (!this.fgfmObs) {
        this.fgfmObs = this.finishedGetFormModaliteList.subscribe(() => {
          if (!qParams['modal']) this.selectedModa = Number(this.listModalite[0].id);
          else this.setSelectedModa(qParams);
        });
      } else {
        this.setSelectedModa(qParams);
      }
      if (qParams['postal']) {
        this.postal = qParams['postal'];
      } else {
        this.postal = '';
      }
    });
  }

  ngOnDestroy(): void {
    this.queryObs.unsubscribe();
    this.fgfmObs.unsubscribe();
  }

  setSelectedModa(qParams) {
    let posibilities: number[];
    if (this.listModalite && this.listModalite.length) {
      posibilities = this.listModalite.map(moda => moda.id);
    } else {
      posibilities = this.defaultModa;
    }
    const paramsIsCorrect = posibilities.indexOf(Number((qParams || ({} as any)).moda || 0)) !== -1;
    this.selectedModa = paramsIsCorrect ? Number(qParams.moda) : posibilities[0];
    if (!paramsIsCorrect) {
      const queryParams = { moda: this.selectedModa };
      this.router.navigate([], { queryParams });
    }
  }

  getFormModaliteList(idProduit: number, isParcours: boolean) {
    this.formationService.getFormModaliteList(idProduit, isParcours).subscribe(
      info => {
        this.listModalite = info;
        this.finishedGetFormModaliteList.next(true);
      },
      () => {
        this.listModalite = [
          { libelle: 'Présentiel', id: 1 },
          { libelle: 'Blended', id: 2 },
          { libelle: 'E-learning', id: 3 }
        ];
        this.selectedModa = 1;
        this.postal = '';
        this.finishedGetFormModaliteList.next(true);
      }
    );
  }

  getBackgroundStyle() {
    if (this.infoFormation && this.infoFormation.backgroundPictureUri) {
      return {
        'background-image': `url('${this.infoFormation.backgroundPictureUri}')`,
        'background-position': 'center',
        'background-size': 'cover',
        position: 'absolute',
        top: '0',
        left: '0',
        width: '100%',
        height: '100%',
        opacity: '0.33',
        'z-index': '-1'
      };
    }
    return this.styleBGColor;
  }

  changeModalite(modalite) {
    const queryParams = { moda: modalite.id };
    this.selectedModa = modalite.id;
    if (this.postal) {
      Object.assign(queryParams, { postal: this.postal });
    }
    this.router.navigate([], { queryParams });
  }

  onPostalValueChange(event: KeyboardEvent) {
    const input = event.target as HTMLInputElement;
    const newVal = input.value;
    this.keyupObservable.next(newVal);
  }

  listenKeyup() {
    this.keyupObservable.pipe(throttleTime(500)).subscribe((val: any) => {
      const newVal = val.target.value;
      this.postal = newVal;
      const queryParams = { moda: this.selectedModa };
      this.postal = newVal.replace(/[^0-9]/gi, '').slice(0, 5);
      if (this.postal) {
        Object.assign(queryParams, { postal: this.postal });
      }
      this.router.navigate([], { queryParams });
    });
  }
}
